'use strict';

/*
globals
PageLoading,
Navigation,
Style,
Attributes,
DataTables,
Messages,
Select,
Search,
Forms,
Buttons,
Environment,
Accordion,
Header,
BigTarget,
BigCheckboxes,
GAEventTriggers,
StaticElement
*/

var pageLoading = new PageLoading();
var search = new Search();
var select = new Select();
var accordion = new Accordion();
var dataTables = new DataTables();
var style = new Style();
var attributes = new Attributes();
var navigation = new Navigation();
var messages = new Messages();
var forms = new Forms();
var buttons = new Buttons();
var environment = new Environment();
var header = new Header();
var bigTarget = new BigTarget();
var bigCheckboxes = new BigCheckboxes();
var gaEventTriggers = new GAEventTriggers();
var staticElement = new StaticElement();

$(document).ready(function () {
    pageLoading.initPageLoading();
    search.initSearch();
    select.initSelects();
    accordion.initAccordions();
    dataTables.initDataTables();
    forms.initForms();
    buttons.initButtons();
    style.applyStyle();
    attributes.applyAttributes();
    navigation.initNavigation();
    messages.initMessages();
    environment.initEnvironment();
    header.initHeader();
    bigTarget.initBigTarget();
    bigCheckboxes.initCheckboxes();
	gaEventTriggers.initGAEventTriggers();
    staticElement.initStaticElement();
});
